export default __webpack_public_path__ + "static/media/tab-bg.53f7ddd6.svg";